var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue } from "vue-property-decorator";
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import { Student } from '@/models/Student';
import ErrorHandler from "@/support/ErrorHandler";
import _ from 'lodash';
import { downloadExcel } from '@/support/Client';
let PortfolioArchives = class PortfolioArchives extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.resultFiles = [];
        this.deleteResultList = [];
        this.isDownloadingPortfolioPage = false;
        this.isEditing = false;
        this.isUpdating = false;
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.portfolioClone = _.cloneDeep(this.portfolio);
        this.filterFiles();
    }
    filterFiles() {
        if (!this.portfolioClone || !this.portfolioClone.files) {
            return;
        }
        this.resultFiles = this.portfolioClone.files.filter((file) => {
            return file.collection === 'archive';
        });
    }
    resetResults() {
        this.deleteResultList = [];
        this.resultFiles = _.cloneDeep(this.portfolio).files;
        this.filterFiles();
        this.isEditing = false;
    }
    deleteResult(deletedFile) {
        this.resultFiles = this.resultFiles.filter((file) => {
            return file.id !== deletedFile.id;
        });
        this.deleteResultList.push(deletedFile);
    }
    downloadPortfolioPage() {
        if (!this.portfolio) {
            return;
        }
        this.isDownloadingPortfolioPage = true;
        new PortfolioModel()
            .include(['interests', 'skills', 'labels', 'ratings', 'category'])
            .getPdf(this.portfolio.id)
            .then(async (response) => {
            const url = response.data;
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank');
            link.setAttribute('download', `portfolio-${this.student.name}.pdf`);
            document.body.appendChild(link);
            link.click();
            this.isDownloadingPortfolioPage = false;
            const portfolio = await new PortfolioModel().include(['files']).find(this.portfolio.id);
            this.portfolioClone.files = portfolio.files;
            this.filterFiles();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    async downloadPortfolioPageToComputer() {
        if (!this.portfolio) {
            return;
        }
        this.isDownloadingPortfolioPage = true;
        const options = {
            url: `v3/portfolios/${this.portfolio.id}?download=true&with%5B%5D=interests&with%5B%5D=skills&with%5B%5D=labels&with%5B%5D=ratings&with%5B%5D=category`,
            accept: 'application/pdf',
        };
        await downloadExcel(options);
        this.isDownloadingPortfolioPage = false;
    }
    updateResults() {
        this.deleteResultList.forEach((file) => {
            new PortfolioModel()
                .deleteFileFromPortfolio(this.portfolio.id, file.id)
                .then(() => {
                this.$emit('portfolioUpdated');
                this.deleteResultList = [];
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    get user() {
        return this.$store.state.Auth;
    }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.result.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: async () => {
                        await this.updateResults();
                        this.isEditing = false;
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdating = false;
                    },
                },
            },
        };
    }
};
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_a = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _a : Object)
], PortfolioArchives.prototype, "portfolio", void 0);
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_b = typeof Student !== "undefined" && Student) === "function" ? _b : Object)
], PortfolioArchives.prototype, "student", void 0);
PortfolioArchives = __decorate([
    Component({})
], PortfolioArchives);
export default PortfolioArchives;
